import { useEffect } from 'react';

import useBrandName from './useBrandName';

const useDocumentTitle = (title?: string) => {
	const brandName = useBrandName();

	useEffect(() => {
		document.title = title ? `${title} - ${brandName}` : brandName;
	}, [title, brandName]);
};

export default useDocumentTitle;
